module.exports = __webpack_public_path__ + "img/useFlow-small-bg2.24b55b0.png";